import {
  Box,
  CircularProgress,
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@material-ui/core';
import { forwardRef } from 'react';

export type IconButtonProps = MuiIconButtonProps & {
  loading?: boolean;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ loading = false, children, disabled, size, ...props }, ref) => {
    const progressSize = size === 'small' ? 15 : 20;

    return (
      <MuiIconButton
        ref={ref}
        disabled={disabled || loading}
        size={size}
        {...props}
      >
        {loading ? (
          <Box display="flex" alignItems="center" justifyContent="center">
            <CircularProgress size={progressSize} color="inherit" />
          </Box>
        ) : (
          children
        )}
      </MuiIconButton>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;
